module.exports = __webpack_public_path__ + "img/Weapon_190.cb5cb963.png";